import { render, staticRenderFns } from "./EvaluationReportWizardModal.vue?vue&type=template&id=b8ef4fb8&scoped=true"
import script from "./EvaluationReportWizardModal.vue?vue&type=script&lang=ts"
export * from "./EvaluationReportWizardModal.vue?vue&type=script&lang=ts"
import style0 from "./EvaluationReportWizardModal.vue?vue&type=style&index=0&id=b8ef4fb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ef4fb8",
  null
  
)

export default component.exports